<div class="fs-2 with-close" mat-dialog-title>
    Informations de facturation
    <i class="fa fa-close" (click)="onNoClick()" aria-hidden="true"></i>
</div>
<div mat-dialog-content class="pb-0">
    <div class="duration_choose mb-4 {{ plan == 'pro' ? 'duration_2' : ''}}">
        <div class="duration {{ duration == 'month' ? 'active' : ''}}" (click)="setDuration('month')">
            Mensuel
        </div>
        <div *ngIf="plan != 'pro'" class="duration {{ duration == 'quarter' ? 'active' : ''}}" (click)="setDuration('quarter')">
            Trimestriel
            <div class="discount">
                -10%
            </div>
        </div>
        <div class="duration {{ duration == 'year' ? 'active' : ''}}" (click)="setDuration('year')">
            Annuel
            <div *ngIf="plan != 'pro'" class="discount">
                -20%
            </div>
        </div>
    </div>
    <form [formGroup]="accountForm">
        <div class="card-text row">
            <div class="col-lg-6">
                <mat-form-field>
                    <mat-label>Prénom</mat-label>
                    <input matInput formControlName="firstName" class="text">
                    <mat-error *ngIf="accountForm.get('firstName').invalid">
                        {{formService.getErrorMessage(accountForm.get('firstName'))}}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-lg-6">
                <mat-form-field>
                    <mat-label>Nom</mat-label>
                    <input matInput formControlName="lastName" class="text">
                    <mat-error *ngIf="accountForm.get('lastName').invalid">
                        {{formService.getErrorMessage(accountForm.get('lastName'))}}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-lg-6">
                <mat-form-field>
                    <mat-label>Société (facultatif)</mat-label>
                    <input matInput formControlName="company_name" class="text">
                    <mat-error *ngIf="accountForm.get('company_name').invalid">
                        {{formService.getErrorMessage(accountForm.get('company_name'))}}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-lg-6">
                <mat-form-field>
                    <mat-label>Mobile (facultatif)</mat-label>
                    <input matInput formControlName="mobile" class="text">
                    <mat-error *ngIf="accountForm.get('mobile').invalid">
                        {{formService.getErrorMessage(accountForm.get('mobile'))}}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-lg-12">
                <mat-form-field>
                    <mat-label>Adresse</mat-label>
                    <textarea formControlName="adress" matInput placeholder=""></textarea>
                    <mat-error *ngIf="accountForm.get('adress').invalid">
                        {{formService.getErrorMessage(accountForm.get('adress'))}}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-lg-6">
                <mat-form-field>
                    <mat-label>Code postal</mat-label>
                    <input formControlName="zip_code" matInput class="text">
                    <mat-error
                        *ngIf="accountForm.get('zip_code').invalid">{{formService.getErrorMessage(accountForm.get('zip_code'))}}</mat-error>
                </mat-form-field>
            </div>
            <div class="col-lg-6">
                <mat-form-field>
                    <mat-label>Ville</mat-label>
                    <input formControlName="city" matInput class="text">
                    <mat-error
                        *ngIf="accountForm.get('city').invalid">{{formService.getErrorMessage(accountForm.get('city'))}}</mat-error>
                </mat-form-field>
            </div>
        </div>
    </form>
</div>
<div mat-dialog-actions>
    <button (click)="onNoClick()" type="reset" class="btn btn-outline">
        Annuler
    </button>
    <button (click)="onYesClick()" type="submit" class="btn btn-primary">
        <mat-spinner diameter="26" *ngIf="loading"></mat-spinner>
        <ng-container *ngIf="!loading">Valider</ng-container>
    </button>
</div>
